export default __webpack_public_path__ + "static/media/blank.59a481aa.jpg";